
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import { ElMessage } from "element-plus";
import MiezzButton from "@/models/MiezzButton";
import MiezzForm from "@/models/MiezzForm";
import MiezzModal from "@/models/MiezzModal";
import CompanyFollowUpRecordAppService from "@/apis.machine/CompanyFollowUpRecordAppService";
import DtoDetailCompanyFollowUpRecord, {
  DtoDetailCompanyFollowUpRecordMiezzDetailItems,
} from "@/models.machine/DtoDetailCompanyFollowUpRecord";
import { EnumCompanyType } from "@/models.machine/EnumCompanyType";

export default class CompanyFollowUpRecordDetail extends Vue {
  @Prop() type?: EnumCompanyType;
  @Prop() detail!: MiezzForm<DtoDetailCompanyFollowUpRecord, string>;

  id?: string;

  modalForm = new MiezzModal();
  buttons: MiezzButton[] = [
    {
      Code: "back",
      Label: "返回",
      MiezzIcon: "back",
      Type: "text",
      Size: "small",
    },
    {
      Code: "edit",
      Label: "编辑",
      Icon: "edit",
      Type: "text",
      Size: "small",
    },
  ];

  /**创建时 */
  created(): void {
    this.id = this.$route.params.id as string;
    //详细-数据-初始化
    this.detail.Data = new DtoDetailCompanyFollowUpRecord();
    //详细-元素配置
    this.detail.Items = DtoDetailCompanyFollowUpRecordMiezzDetailItems;
    for (const item of this.detail.Items) {
      if (item.Prop == "CustomerLabel") {
        item.Label =
          this.type == EnumCompanyType.Customer ? "客户企业" : "供应商企业";
      }
    }
    this.detail.DefaultSpan = 8;
    for (const item of this.detail.Items ?? []) {
      switch (item.Prop) {
        case "Methods":
          item.HandleFormat = () => {
            return this.detail.Data.Methods?.length == 1
              ? this.detail.Data.Methods.firstOrDefault()?.Method
              : this.detail.Data.Methods?.map((it) => `【${it.Method}】`).join(
                  ""
                );
          };
          break;
        case "Contents":
          item.HandleFormat = () => {
            return this.detail.Data.Contents?.length == 1
              ? this.detail.Data.Contents.firstOrDefault()?.Content
              : this.detail.Data.Contents?.map(
                  (it) => `【${it.Content}】`
                ).join("");
          };
          break;
        case "InnerAccompanyPeople":
          item.HandleFormat = () => {
            return this.detail.Data.InnerAccompanyPeople?.length == 1
              ? this.detail.Data.InnerAccompanyPeople.firstOrDefault()
                  ?.InnerAccompanyPersonLabel
              : this.detail.Data.InnerAccompanyPeople?.map(
                  (it) => `【${it.InnerAccompanyPersonLabel}】`
                ).join("");
          };
          break;
        default:
          break;
      }
    }
    this.handleGet();
  }

  /**查询详细 */
  handleGet(): void {
    if (this.id) {
      CompanyFollowUpRecordAppService.GetById(this.id).then((r) => {
        if (r.data.Data) this.detail.Data = r.data.Data;
        this.detail.Data.Code = this.detail.Data.Id;
      });
    }
  }

  handleLinkClick(): void {
    if (
      this.detail.Data.Link &&
      /^(http|https):\/\/[a-zA-Z0-9.-]+(:[0-9]+)?(\/[^ ]*)?$/.test(
        this.detail.Data.Link
      )
    ) {
      window.open(this.detail.Data.Link);
    } else {
      ElMessage.warning("链接地址无效，无法打开");
    }
  }

  /**按钮点击 */
  handleClick(btn: MiezzButton, complete: () => void): void {
    const listUrl = this.$route.path.substring(
      0,
      this.$route.path.indexOf("/detail")
    );
    switch (btn.Code) {
      case "edit":
        this.$router.push(`${listUrl}/edit/${this.id}`);
        complete();
        break;
      default:
        break;
    }
  }
}
